// Utilități pentru formatare date + calcul urgență expirare documente.

const MS_DAY = 24 * 60 * 60 * 1000;

export function daysUntil(iso) {
  if (!iso) return null;
  const target = new Date(iso);
  const now = new Date();
  // Comparăm doar datele (fără ore), ca să nu avem surprize la miezul nopții
  const t = new Date(target.getFullYear(), target.getMonth(), target.getDate()).getTime();
  const n = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
  return Math.round((t - n) / MS_DAY);
}

// Returnează: 'expired' | 'danger' (<7 zile) | 'warn' (<30 zile) | 'ok' | null (fără dată)
export function expiryStatus(iso) {
  if (!iso) return null;
  const d = daysUntil(iso);
  if (d < 0) return 'expired';
  if (d <= 7) return 'danger';
  if (d <= 30) return 'warn';
  return 'ok';
}

const roFormatter = new Intl.DateTimeFormat('ro-RO', {
  day: '2-digit',
  month: 'short',
  year: 'numeric',
});

export function formatDate(iso) {
  if (!iso) return '—';
  return roFormatter.format(new Date(iso));
}

export function formatRelative(iso) {
  const d = daysUntil(iso);
  if (d === null) return '—';
  if (d === 0) return 'azi';
  if (d === 1) return 'mâine';
  if (d === -1) return 'ieri';
  if (d > 0) return `în ${d} zile`;
  return `acum ${-d} zile`;
}
